import { render, staticRenderFns } from "./ReactionGrid.vue?vue&type=template&id=05ba6044&scoped=true&"
import script from "./ReactionGrid.vue?vue&type=script&lang=js&"
export * from "./ReactionGrid.vue?vue&type=script&lang=js&"
import style0 from "./ReactionGrid.vue?vue&type=style&index=0&id=05ba6044&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05ba6044",
  null
  
)

/* custom blocks */
import block0 from "./ReactionGrid.vue?vue&type=custom&index=0&blockType=docs"
if (typeof block0 === 'function') block0(component)

export default component.exports